import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Microenvironment, UserActivity, Intensity, UserExercise } from '../models/user-inputs';
import { UserInputsService } from '../services/user-inputs.service';

@Component({
  selector: 'app-about-my-day',
  templateUrl: './about-my-day.component.html',
  styleUrls: ['./about-my-day.component.css']
})
export class AboutMyDayComponent implements OnInit {
  
  Microenvironment = Microenvironment;
  userActivity!: UserActivity;
  envs = [Microenvironment.vehicles, Microenvironment.outdoors, Microenvironment.other];
  
  Intensity = Intensity;
  userExercise!: UserExercise;
  intensities = [Intensity.light, Intensity.moderate, Intensity.vigorous];

  constructor(
    private router: Router,
    private userInputsService: UserInputsService
  ) { }

  ngOnInit(): void {
    this.userActivity = {...this.userInputsService.userActivity};
    this.userExercise = {...this.userInputsService.userExercise};
  }
  
  timeSpentIndoorsAtHome(): number {
    return 24 - (this.userActivity[Microenvironment.outdoors] +
      this.userActivity[Microenvironment.vehicles] +
      this.userActivity[Microenvironment.other]);
  }
  
  sedentaryTime(env: Microenvironment): number {
    let total = this.userActivity[env]*60;
    if (env == Microenvironment.home) {
      total = this.timeSpentIndoorsAtHome()*60;
    }
    return total - (this.userExercise[env][Intensity.light] +
      this.userExercise[env][Intensity.moderate] +
      this.userExercise[env][Intensity.vigorous]);
  }

  save(): void {
    this.userInputsService.userActivity = {...this.userActivity};
    this.userInputsService.userExercise = {...this.userExercise};
    this.router.navigate([''], { skipLocationChange: true });
  }
}
